















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class IdrBiduiDianquan extends Vue {
  @Prop()
  private message: any;
}
